import React from "react";
import { SearchFundCard, CanCan, Permissions } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import { Input, Button } from "@public/ui-toolkit";
import debounce from "lodash/debounce";
import { getMyFunds } from "./actions";
import { useHistory } from "react-router-dom";

const SearchFund = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [search, setSearch] = React.useState("");
  const [paginationInfo, setPaginationInfo] = React.useState({
    page: 1,
    perPage: 20,
  });

  const myFundsStore = useSelector((state) => state.myFundsReducer);

  const { myFunds, rows } = myFundsStore;

  const handleSearch = debounce((text) => {
    setSearch(text);
  }, 1000);

  // const handleSearch = (e) => {
  //   e.preventDefault();
  //   setPaginationInfo({ ...paginationInfo, page: 1 });
  //   const payload = {
  //     keyword: search,
  //     page: 1,
  //     perPage: paginationInfo.perPage,
  //   };
  //   dispatch(getSearchAllocators(payload));
  // };

  const handleMore = () => {
    const payload = {
      keyword: search,
      page: paginationInfo.page + 1,
      perPage: paginationInfo.perPage,
    };
    dispatch(getMyFunds(payload));
    setPaginationInfo({ ...paginationInfo, page: paginationInfo.page + 1 });
  };

  const getNumberWithUnit = (number) => {
    if (number >= 1e3) {
      var units = ["K", "M", "B", "T"];
      let unit = Math.floor((number.toFixed(0).length - 1) / 3) * 3;
      var num = (number / ("1e" + unit)).toFixed(2);
      var unitName = units[Math.floor(unit / 3) - 1];
      return num + unitName;
    }
  };

  React.useEffect(() => {
    setPaginationInfo({ ...paginationInfo, page: 1 });
    const payload = {
      keyword: search,
      page: 1,
      perPage: paginationInfo.perPage,
    };
    dispatch(getMyFunds(payload));
  }, [search, dispatch]);

  // React.useEffect(() => {
  //   const payload = {
  //     keyword: search,
  //     page: paginationInfo.page,
  //     perPage: paginationInfo.perPage,
  //   };
  //   dispatch(getSearchAllocators(payload));
  // }, []);

  return (
    <main>
      <div className="main-inner">
        <div className="container mt-5">
          {/* <div className="main-content-header py-4">
            <Breadcrumbs item1="Search Funds" />
          </div> */}
          <div className="d-flex">
            <h4 className="stylish-title text-blue">My Funds</h4>
            <CanCan permissionName={Permissions?.FUND_CREATE?.name}>
              <Button
                btnName="Create Fund Request"
                onClick={() => {
                  history.push("/createfund");
                }}
              />
            </CanCan>
          </div>
          <div className="fund-searching mt-4">
            <div className="search-with-btn">
              <form>
                <div className="col-11 mr-3">
                  <Input
                    placeholder="Search"
                    label="Search"
                    onChange={(e) => handleSearch(e.target.value)}
                    type="text"
                    name="search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div className="mt-5">
            <div className="row gy-4">
              {myFunds.map((fund) => (
                <div className="col-xl-3 col-lg-4 col-md-6">
                  <SearchFundCard
                    portalUrl = {"fund"}
                    btnName={fund.followed ? "Followed" : "Follow"}
                    fund={fund}
                    getNumberWithUnit={getNumberWithUnit}
                    isFooterShow={false}
                  />
                </div>
              ))}
            </div>
            {rows > paginationInfo.perPage * paginationInfo.page && (
              <div className="d-flex justify-content-center mt-5">
                <Button btnName="Load More +" onClick={handleMore} />
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
};

export default SearchFund;
